document.addEventListener('DOMContentLoaded', function () {
  class YgMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.isMobile = window.innerWidth < 1150; // 当前状态记录
    }

    connectedCallback() {
      this.init();
      this.bindResizeWatcher();
    }

    init() {
      const menuItems = Array.from(this.querySelectorAll('.yg-mega-menu-item'));
      const productItems = Array.from(this.querySelectorAll('.yg-mega-products-item'));
      const productsContainer = this.querySelector('.yg-mega-menu-products');
      const productsHeaderTitle = this.querySelector('.yg-mega-products-header .yg-mega-menu-title');

      if (!menuItems.length || !productItems.length) return;

      menuItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          menuItems.forEach(i => i.classList.remove('active'));
          productItems.forEach(i => i.classList.remove('active'));

          item.classList.add('active');
          if (productItems[index]) productItems[index].classList.add('active');

          if (window.innerWidth < 1150 && productsContainer) {
            productsContainer.classList.add('active');
          }
        });
      });

      if (productsHeaderTitle) {
        productsHeaderTitle.addEventListener('click', () => {
          if (window.innerWidth < 1150 && productsContainer) {
            productsContainer.classList.remove('active');
          }
        });
      }
    }

    bindResizeWatcher() {
      const productsContainer = this.querySelector('.yg-mega-menu-products');

      window.addEventListener('resize', () => {
        const isNowMobile = window.innerWidth < 1150;

        if (!isNowMobile && this.isMobile && productsContainer) {
          productsContainer.classList.remove('active');
        }

        this.isMobile = isNowMobile;
      });
    }
  }

  if (!customElements.get('yg-mega-menu')) {
    customElements.define('yg-mega-menu', YgMegaMenu);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();

      this.init()
    }

    init() {
      const header = this.querySelector('.yg-accordion__header');
      const content = this.querySelector('.yg-accordion__content');
      console.log('header content',header,content);
      
      const trueHeight = content.scrollHeight;
      content.style.setProperty('--true-height', `${trueHeight}px`);
      let outsideAccordionContent = null;
      if (this.closest('.yg-accordion')) {
        outsideAccordionContent = this.closest('.yg-accordion .yg-accordion__content');
      }

      header.addEventListener('click', () => {
        this.classList.toggle('yg-accordion--open');
        if (this.classList.contains('yg-accordion--open') && outsideAccordionContent) {
          const outsideAccordionHeight = outsideAccordionContent.scrollHeight;
          outsideAccordionContent.style.setProperty('--true-height', `${outsideAccordionHeight + trueHeight }px`);
        } else if(!this.classList.contains('yg-accordion--open')  && outsideAccordionContent) {
          const outsideAccordionHeight = outsideAccordionContent.scrollHeight;
          outsideAccordionContent.style.setProperty('--true-height', `${outsideAccordionHeight - trueHeight }px`);
        }
      });
    }
  }

  if (!window.customElements.get('yg-accordion')) {
    customElements.define('yg-accordion', YGAccordion);
  }

  class YGModal extends HTMLElement {
    constructor() {
      super();
      this.modalTriggers = [];
      this.modals = [];
      this.closeButtons = [];
    }

    connectedCallback() {
      this.init();
      this.moveModalsToBody();
    }

    moveModalsToBody() {
      this.modals = this.querySelectorAll('.yg-modal');
      this.modals.forEach((modal) => {
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }
      });
    }

    init() {
      this.modalTriggers = this.querySelectorAll('.yg-modal-trigger');
      // document
      this.modals = document.querySelectorAll('.yg-modal');
      this.closeButtons = document.querySelectorAll('.yg-modal-close');
      this.bindEvents();
    }

    bindEvents() {
      // open modal
      this.modalTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          const modalId = trigger.getAttribute('data-modal');
          const modal = document.getElementById(modalId);
          if (modal) {
            this.openModal(modal);
          }
        });
      });

      // close modal
      this.closeButtons.forEach((closeBtn) => {
        closeBtn.addEventListener('click', (e) => {
          const modal = closeBtn.closest('.yg-modal');
          this.closeModal(modal);
        });
      });

      // outside click
      this.modals.forEach((modal) => {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            this.closeModal(modal);
          }
        });
      });
    }

    openModal(modal) {
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }

    closeModal(modal) {
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = 'auto';
      }
    }
  }

  if (!customElements.get('yg-modal')) {
    customElements.define('yg-modal', YGModal);
  }
});
